import { useCallback, useEffect, useState } from 'react';
const useDisclosure = ({
  id,
  isExpanded
}) => {
  const [isExpandedState, setIsExpandedState] = useState(!!isExpanded);
  useEffect(() => {
    if (isExpanded !== undefined) {
      setIsExpandedState(isExpanded);
    }
  }, [isExpanded]);
  const toggleIsExpanded = useCallback(() => {
    setIsExpandedState(expanded => !expanded);
  }, [setIsExpandedState]);
  const toggleProps = {
    id: `${id}-toggle`,
    'data-test-id': `${id}-toggle`,
    onClick: toggleIsExpanded,
    'aria-expanded': isExpandedState,
    'aria-controls': `${id}-content`
  };
  const contentProps = {
    id: toggleProps['aria-controls'],
    'data-test-id': toggleProps['aria-controls'],
    'aria-hidden': !isExpanded,
    'aria-labelledby': toggleProps.id
  };
  return {
    toggleProps,
    contentProps,
    isExpanded: isExpandedState,
    toggleIsExpanded
  };
};
export default useDisclosure;